<div class="flex flex-wrap gap-2">
  <div class="flex items-center gap-1">
    <mat-checkbox [(ngModel)]="wiseTested" (change)="updatePublicUnitType()" i18n
      >WISE Tested</mat-checkbox
    >
    <a tabindex="0" (click)="showInfo('official')" (keyup.enter)="showInfo('official')">
      <mat-icon aria-label="WISE Tested explanation" i18n-aria-label>info</mat-icon>
    </a>
  </div>
  <div class="flex items-center gap-1">
    <mat-checkbox [(ngModel)]="communityBuilt" (change)="updatePublicUnitType()" i18n
      >Community Built</mat-checkbox
    >
    <a tabindex="0" (click)="showInfo('community')" (keyup.enter)="showInfo('community')">
      <mat-icon aria-label="Community Built explanation" i18n-aria-label>info</mat-icon>
    </a>
  </div>
</div>
